import { PaymentPlanEntryStatus } from '../../economy/payment-plans/index.js';
import { VoucherTypeIds } from '../../economy/vouchers/index.js';
const map = {
    is: {
        currently: 'nl',
    },
    mentionContent: {
        amortisationRemainingAfterFinalPayment: 'Restschuld na de laatste termijn',
        amortisationForgivenOnCompletion: 'Kwijtgescholden bij succesvolle afronding',
        amortisationDebtAfterSettlement: 'Schuld na succesvolle afronding van de schikking',
        amortisationPaymentDate: 'Betaaldatum',
        amortisationAddedFees: 'Toegevoegde kosten',
        amortisationRemainingAfterPayment: 'Restschuld na betaling',
        amortisationRemainingDebt: 'Restschuld',
        amortisationPrincipal: 'Hoofdsom',
        amortisationCosts: 'Kosten',
        amortisationInterest: 'Rente',
        amortisationAccruedInterest: 'Toegevoegde rente',
        amortisationPayment: 'Termijnbedrag',
        amortisationCurrentBalance: 'Huidig saldo',
        reminderFeeRow: 'Herinneringskosten volgens de Interest Act sectie 9b, subsectie 2',
        debtCollectionFeeRow: 'Incassokosten volgens de Interest Act sectie 9b, subsectie 1',
        debtCollectionCostRow: 'Incassokosten volgens de Interest Act sectie 9a, subsectie 1',
        compensationFeeRow: 'Compensatiekosten volgens de Interest Act sectie 9a, subsectie 3',
        fixedInterestRow: 'Eerder opgebouwde rente',
        processInterestRow: 'Opgelopen rente vanaf de vervaldatum',
        yearlyInterestRow: 'Opgelopen rente',
        otherCosts: 'Overige kosten',
        sum: 'Totaal openstaand',
        subTotal: 'Subtotaal',
        paid: 'Al betaald',
        invoice: 'Factuur',
        caseVoucher: ' ',
        currency: 'Munteenheid',
        date: 'Datum',
        dueDate: 'Vervaldatum',
        amount: 'Bedrag',
        deposited: 'Gestort',
        residue: 'Restant',
        text: 'Tekst',
        appliedToPrincipal: 'Toegepast op hoofdsom',
        appliedToInterest: 'Toegepast op rente',
        appliedToCosts: 'Toegepast op kosten',
        principalBalance: 'Saldo hoofdsom',
        interestBalance: 'Saldo rente',
        costsBalance: 'Saldo kosten',
        expiredSince: 'Waarvan verjaard',
        total: 'Totaal',
        email: 'E-mail',
        phone: 'Telefoon',
        signature: 'Handtekening',
        journalNumber: 'Dossiernummer:',
        genericEmailSubjectPre: 'Betreffende uw schuld aan',
        genericEmailSubjectForAlternativeContactPre: 'Dossier bij',
        satisfactionsOrClick: 'of klik',
        satisfactionsHere: 'hier',
        principalReferenceIdsAnd: ' en ',
        previousYearsAnd: ' en ',
        nameAndAddressProtectedPerson: 'Persoon met naam- en adresbescherming',
    },
    debtorWebPaymentPlans: {
        backToCase: 'Terug naar zaak',
        paymentPlanOn: 'Betalingsplan op zaak',
        selectPlan: 'Selecteer betalingsplan',
        chooseDifferentPlan: 'Kies een ander betalingsplan',
        sign: 'Onderteken overeenkomst',
        gatherInfo: 'Voer informatie in',
        paymentMethod: 'Selecteer betaalmethode',
        approval: 'Goedkeuring',
        info: 'Informatie',
        paymentPlan: 'Betalingsplan',
        firstPayment: 'Eerste betaling',
        entry: 'invoer',
        lastPayment: 'Laatste betaling',
        signedDoc: 'Ondertekend document',
        needHelp: 'Hulp nodig?',
        orPay: 'Of betaal de hele schuld',
        pay: 'Betaal de hele schuld',
        months: 'Maanden',
        month: 'maand',
        total: 'Totale betaling',
        select: 'Selecteer',
        noOptions: 'Helaas is het niet mogelijk om een betalingsplan op te zetten.',
        signTextOne: 'Om je aan te melden voor een betalingsplan met',
        signTextTwoAlternativeContact: 'moet de schuldenaar de volgende overeenkomst ondertekenen.',
        signTextTwoDebtor: 'moet je de volgende overeenkomst ondertekenen.',
        signTextThree: 'Voordat je de overeenkomst kunt ondertekenen, moet je je gegevens invoeren.',
        agreement: 'Onderteken overeenkomst',
        agreementTitle: 'Overeenkomst',
        approvalText: 'Gefeliciteerd. Je hebt een betalingsplan afgesloten.',
        paymentMethodText: 'We zullen zorg dragen voor je kaartinformatie en het eenvoudig maken om je aan te melden voor automatische betaling.',
        connectCard: 'Verbind betaalmethode',
        automaticPaymentMethod: 'Automatische betaalmethode',
        manualBankTransferTitle: 'Liever een handmatige bankoverschrijving?',
        manualBankTransferHint: 'Je kunt in plaats daarvan een handmatige bankoverschrijving doen. De bankgegevens vind je op het zaakoverzicht.',
        securePaymentHint: 'Veilige betaling',
        deleteCardToChange: 'Je kunt de geselecteerde kaart wijzigen/verwijderen door op de knop kaart verwijderen te klikken.',
        deleteCard: 'Verwijder kaart',
        paymentPlanEntries: 'Invoeren betalingsplan',
        progressTitle: 'Jouw betalingsplan',
        progressPaid: 'Betaald',
        progressRemaining: 'Resterend',
        progressNext: 'Volgende termijn',
        progressComplete: 'Betalingsplan voltooid',
        progressOf: 'van',
        amount: 'Bedrag',
        date: 'Datum',
        status: 'Status',
        statusCode: {
            [PaymentPlanEntryStatus.SETTLED]: 'Betaald',
            [PaymentPlanEntryStatus.CANCELED]: 'In gebreke gebleven',
            [PaymentPlanEntryStatus.PENDING]: 'Toekomstig',
            [PaymentPlanEntryStatus.REMINDED]: 'Herinnerd',
            [PaymentPlanEntryStatus.AWAITING]: 'In afwachting',
            [PaymentPlanEntryStatus.OVERDUE]: 'Achterstallig',
            [PaymentPlanEntryStatus.ERRORSETTLED]: 'Mislukte kaarttrekking',
        },
    },
    emailSignature: {
        privacyPolicyText: 'Gegevensverwerking. We kunnen persoonlijke gegevens over u verwerken. U kunt ons privacybeleid hier lezen:',
        regards: 'Met vriendelijke groet',
    },
    pluralEconomyVoucherTypeLabels: {
        [VoucherTypeIds.PRINCIPAL]: 'Hoofdsommen',
        [VoucherTypeIds.INVOICE]: 'Facturen',
        [VoucherTypeIds.ONACCOUNTINVOICE]: 'Facturen op rekening',
        [VoucherTypeIds.FINALINVOICE]: 'Eindafrekeningen',
        [VoucherTypeIds.CONTROLFEE]: 'Controlekosten',
        [VoucherTypeIds.ADMINISTRATIONCOST]: 'Administratiekosten',
        [VoucherTypeIds.UDTRAEKSGEBYR]: 'Opnamekosten',
        [VoucherTypeIds.CREDITNOTE]: "Creditnota's",
        [VoucherTypeIds.YEARLYINTEREST]: 'Jaarlijkse rentes',
        [VoucherTypeIds.MONTHLYINTEREST]: 'Maandelijkse rentes',
        [VoucherTypeIds.STARTEDMONTHINTEREST]: 'Rentes per begonnen maand',
        [VoucherTypeIds.PROCESSINTEREST]: 'Rentes',
        [VoucherTypeIds.GLPROCESSINTEREST]: 'Rentes (GL)',
        [VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Samengestelde rente (dagelijkse rentebijschrijving)',
        [VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Samengestelde rente (maandelijkse rentebijschrijving)',
        [VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Samengestelde rente (kwartaalrentebijschrijving)',
        [VoucherTypeIds.REMINDERFEE]: 'Herinneringskosten',
        [VoucherTypeIds.COLLECTIONCOST]: 'Incassokosten',
        [VoucherTypeIds.COLLECTIONFEE]: 'Incasso-fee',
        [VoucherTypeIds.BAILIFFSFEE]: 'Deurwaarderskosten',
        [VoucherTypeIds.WRITFEE]: 'Schrijfkosten',
        [VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Gerechtskosten zonder civiele rechtbank',
        [VoucherTypeIds.COURTCLAIMSALARY]: 'Salarissen gerechtsclaims',
        [VoucherTypeIds.BAILIFSSALARY]: 'Salarissen deurwaarders',
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Kosten gerechtsdeurwaardersrequisitie',
        [VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Kosten politiepresentatie',
        [VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Gerechtskosten met deurwaardersrechtbank',
        [VoucherTypeIds.WRITSALARY]: 'Schrijfsalarissen',
        [VoucherTypeIds.COMPENSATIONCOST]: 'Compensatiekosten',
        [VoucherTypeIds.Folkeregisteropslag]: 'Bevolkingsregister opzoeken',
        [VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Zaken intellectueel eigendom',
        [VoucherTypeIds.CIVILCOURTCOST]: 'Kosten civiele rechtbank',
        [VoucherTypeIds.DEPOSIT]: 'Stortingen',
        [VoucherTypeIds.WITHDRAWAL]: 'Opnames',
        [VoucherTypeIds.OVERPAYMENT]: 'Te veel betaald',
        [VoucherTypeIds.COLLECTIONCOMMISSION]: 'Incassoprovisies',
        [VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Incassoprovisies (toezicht)',
        [VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Incassoprovisies (crediteurgarantie)',
        [VoucherTypeIds.JURIDISKBISTAND]: 'Juridische bijstand',
        [VoucherTypeIds.ENDCASEFEE]: 'Einde van de zaak kosten',
        [VoucherTypeIds.STARTCASEFEE]: 'Begin van de zaak kosten',
        [VoucherTypeIds.BPKFEE]: 'BPK-kosten',
        [VoucherTypeIds.FOGEDFEE]: 'Kosten gerechtsdeurwaardersrequisitie',
        [VoucherTypeIds.DEBTREGISTERREGISTRATIONFEE]: 'Schuldregister-registratiekosten',
        [VoucherTypeIds.BPKDISBURSEMENT]: 'Uitgaven voor schrijven',
        [VoucherTypeIds.POLICEDISBURSEMENT]: 'Uitgaven voor politiepresentatie',
        [VoucherTypeIds.FOGEDDISBURSEMENT]: 'Uitgaven voor gerechtsdeurwaardersrequisitie',
        [VoucherTypeIds.VAT]: 'BTW',
        [VoucherTypeIds.GAELDSBREV]: 'Lening',
        [VoucherTypeIds.SETTLEMENT]: 'Schikking',
        [VoucherTypeIds.FIXEDINTEREST]: 'Vaste rente',
        [VoucherTypeIds.DEPOSITPAYOUT]: 'Uitbetalingen van storting',
        [VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Inschrijvingen in het bevolkingsregister',
        [VoucherTypeIds.ANMELDELSEAFKRAV]: 'Melding van vordering',
        [VoucherTypeIds.MeetingFee]: 'Vergoeding voor vergaderingen',
        [VoucherTypeIds.STAEVNINGSGEBYR]: 'Schrijfkosten',
        [VoucherTypeIds.BERAMMELSESAFGIFT]: 'Afspraakkosten',
        [VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Annulering van beslaglegging',
        [VoucherTypeIds.LOCKSMITHFEE]: 'Slotenmakerkosten',
        [VoucherTypeIds.DRIVINGFEE]: 'Rijdkosten',
        [VoucherTypeIds.OTHERFEE]: 'Andere kosten',
        [VoucherTypeIds.REFUND]: 'Terugbetaling',
        [VoucherTypeIds.JOINTDEPOSIT]: 'Solidarische betalingen',
        [VoucherTypeIds.SEPROCESSINTEREST]: 'Vertragingsrente (Zweden)',
        [VoucherTypeIds.SEKRONOFOGDENAPPLICATIONFEE]: 'Griffierechten (Kronofogden)',
        [VoucherTypeIds.SEKRONOFOGDENREPRESENTATIONFEE]: 'Gemachtigdenvergoeding (betalingsbevel)',
        [VoucherTypeIds.NOLATEINTEREST]: 'Vertragingsrente (Noorwegen)',
        [VoucherTypeIds.NOFORLIKSRADFEE]: 'Griffierechten (verzoeningsraad)',
        [VoucherTypeIds.NOLEGALCOLLECTIONFEE]: 'Verhoogde incassokosten (gerechtelijk)',
    },
    economyVoucherTypeLabels: {
        [VoucherTypeIds.PRINCIPAL]: 'Hoofdsom',
        [VoucherTypeIds.INVOICE]: 'Factuur',
        [VoucherTypeIds.ONACCOUNTINVOICE]: 'Factuur op rekening',
        [VoucherTypeIds.FINALINVOICE]: 'Laatste afrekening',
        [VoucherTypeIds.CONTROLFEE]: 'Controlekost',
        [VoucherTypeIds.ADMINISTRATIONCOST]: 'Administratiekost',
        [VoucherTypeIds.UDTRAEKSGEBYR]: 'Uittrekkingskosten',
        [VoucherTypeIds.CREDITNOTE]: 'Kredietnota',
        [VoucherTypeIds.YEARLYINTEREST]: 'Jaarlijkse rente',
        [VoucherTypeIds.MONTHLYINTEREST]: 'Maandelijkse rente',
        [VoucherTypeIds.STARTEDMONTHINTEREST]: 'Rente per begonnen maand',
        [VoucherTypeIds.PROCESSINTEREST]: 'Rente',
        [VoucherTypeIds.GLPROCESSINTEREST]: 'Rente (GL)',
        [VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Samengestelde rente (dagelijkse rentebijschrijving)',
        [VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Samengestelde rente (maandelijkse rentebijschrijving)',
        [VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Samengestelde rente (kwartaalrentebijschrijving)',
        [VoucherTypeIds.REMINDERFEE]: 'Herinneringskost',
        [VoucherTypeIds.COLLECTIONCOST]: 'Inkassokost',
        [VoucherTypeIds.COLLECTIONFEE]: 'Inkasso-fee',
        [VoucherTypeIds.COMPENSATIONCOST]: 'Compensatiekost',
        [VoucherTypeIds.Folkeregisteropslag]: 'Bevolkingsregister opzoeken',
        [VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Intellectuele eigendomszaken',
        [VoucherTypeIds.DEPOSIT]: 'Storting',
        [VoucherTypeIds.WITHDRAWAL]: 'Opname',
        [VoucherTypeIds.OVERPAYMENT]: 'Overbetaling',
        [VoucherTypeIds.COLLECTIONCOMMISSION]: 'Inkassocommissie',
        [VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Inkassocommissie (toezicht)',
        [VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Inkassocommissie (crediteur storting)',
        [VoucherTypeIds.JURIDISKBISTAND]: 'Juridische bijstand',
        [VoucherTypeIds.ENDCASEFEE]: 'Einde van de zaak kost',
        [VoucherTypeIds.STARTCASEFEE]: 'Begin van de zaak kost',
        [VoucherTypeIds.BPKFEE]: 'BPK-kost',
        [VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisitions-kost',
        [VoucherTypeIds.DEBTREGISTERREGISTRATIONFEE]: 'Schuldregister-registratiekost',
        [VoucherTypeIds.BPKDISBURSEMENT]: 'Schrijfuitbetaling',
        [VoucherTypeIds.POLICEDISBURSEMENT]: 'Uitbetaling politiepresentatie',
        [VoucherTypeIds.FOGEDDISBURSEMENT]: 'Uitbetaling van gerechtsdeurwaardersrequisitie',
        [VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Gerechtskosten zonder civiele rechtbank',
        [VoucherTypeIds.COURTCLAIMSALARY]: 'Salaris voor gerechtsclaims',
        [VoucherTypeIds.VAT]: 'BTW',
        [VoucherTypeIds.BAILIFFSFEE]: 'Kosten deurwaarder',
        [VoucherTypeIds.BAILIFSSALARY]: 'Salaris deurwaarder',
        [VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Kosten politiepresentatie',
        [VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Gerechtskosten met deurwaardersrechtbank',
        [VoucherTypeIds.CIVILCOURTCOST]: 'Omkostingen burgerlijke rechtbank',
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Kosten gerechtsdeurwaardersrequisitie',
        [VoucherTypeIds.WRITFEE]: 'Schrijfkosten',
        [VoucherTypeIds.WRITSALARY]: 'Salaris voor schrijven',
        [VoucherTypeIds.GAELDSBREV]: 'Lening',
        [VoucherTypeIds.SETTLEMENT]: 'Schikking',
        [VoucherTypeIds.FIXEDINTEREST]: 'Vaste rente',
        [VoucherTypeIds.DEPOSITPAYOUT]: 'Uitbetaling van storting',
        [VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Inschrijvingen in het bevolkingsregister',
        [VoucherTypeIds.ANMELDELSEAFKRAV]: 'Melding van vordering',
        [VoucherTypeIds.MeetingFee]: 'Vergoeding voor vergaderingen',
        [VoucherTypeIds.STAEVNINGSGEBYR]: 'Schrijfkosten',
        [VoucherTypeIds.BERAMMELSESAFGIFT]: 'Afspraakkosten',
        [VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Annulering van beslaglegging',
        [VoucherTypeIds.LOCKSMITHFEE]: 'Slotenmakerkosten',
        [VoucherTypeIds.DRIVINGFEE]: 'Rijdkosten',
        [VoucherTypeIds.OTHERFEE]: 'Andere kosten',
        [VoucherTypeIds.REFUND]: 'Terugbetaling',
        [VoucherTypeIds.JOINTDEPOSIT]: 'Solidarische betaling',
        [VoucherTypeIds.SEPROCESSINTEREST]: 'Vertragingsrente (Zweden)',
        [VoucherTypeIds.SEKRONOFOGDENAPPLICATIONFEE]: 'Griffierecht (Kronofogden)',
        [VoucherTypeIds.SEKRONOFOGDENREPRESENTATIONFEE]: 'Gemachtigdenvergoeding (betalingsbevel)',
        [VoucherTypeIds.NOLATEINTEREST]: 'Vertragingsrente (Noorwegen)',
        [VoucherTypeIds.NOFORLIKSRADFEE]: 'Griffierecht (verzoeningsraad)',
        [VoucherTypeIds.NOLEGALCOLLECTIONFEE]: 'Verhoogde incassokosten (gerechtelijk)',
    },
};
export default map;
//# sourceMappingURL=nl.js.map